<div *ngIf="sort?.order">
    <icc-icon name="expand_less" *ngIf="sort.order === 'desc'"></icc-icon>
    <icc-icon name="expand_more" *ngIf="sort.order === 'asc'"></icc-icon>
</div>
<div *ngIf="sort?.index">{{ sort.index }}</div>